let counter = 0;
const interval = setInterval(() => {
    const template = BSS_B2B?.shopData?.template;
    if (template === "product") {
        const container = document.querySelector(".product__info-wrapper");
        if (!container) return;
        const checkout = container.querySelector(".shopify-payment-button");
        checkout.style.display = "none";
        clearInterval(interval);
    }
    counter += 100;
    if (counter >= 10000) {
        clearInterval(interval);
    }
}, 100);

const soldoutBtn = document.querySelector(
  ".product-form__submit.button.button--full-width"
);

if (
  soldoutBtn &&
  soldoutBtn.textContent.trim().toLowerCase() === "sold out"
) {
  soldoutBtn.textContent =
    "Sold Out – Temporarily out of stock. New inventory coming soon!";
}
